<template>
  <b-row class="admin-customers-row mx-0 mt-5">
    <b-col
      md="12"
      xl="12"
      lg="12"
      class="admin-customers-column d-flex"
      :style="{padding: '1.25rem'}"
    >
      <b-col md="2" class="">
        <h6 class="font-sm primary--text font-family-medium">Customer name</h6>
      </b-col>
      <b-col md="2" class="">
        <h6 class="font-sm primary--text font-family-medium">
          Subscription type
        </h6>
      </b-col>
      <b-col md="2" class="">
        <h6 class="font-sm primary--text font-family-medium">Company name</h6>
      </b-col>
      <b-col md="2" class="">
        <h6 class="font-sm primary--text font-family-medium">Assigned to</h6>
      </b-col>
      <b-col md="2" class="">
        <h6 class="font-sm primary--text font-family-medium">Owner</h6>
      </b-col>
      <b-col class="" cols="1">
        <h6 class="font-sm primary--text font-family-medium">Date</h6>
      </b-col>
      <b-col class="d-flex justify-space-evenly" cols="1">
        <h6 class="font-sm primary--text font-family-medium">Actions</h6>
      </b-col>
    </b-col>

    <div class="w-100">
      <b-col
        v-for="customer in currentCustomersList"
        :key="customer.id"
        md="12"
        xl="12"
        lg="12"
        class="px-0 py-2 admin-customers-column cy-current-customers-list"
      >
        <b-card
          @mouseenter="showCardHover(customer.id)"
          @mouseleave="undoCardHover(customer.id)"
          @click="navigate(customer)"
          no-body
        >
          <b-card-body class=" py-4 d-flex align-items-center">
            <b-col
              cols="2"
              class="cy-current-customer-details d-flex align-items-center"
            >
              <b-avatar
                class="customer-avatar bg--primary"
                size="4.4rem"
                :src="customer.user.avatarThumbnail"
                :text="userInitials(customer.user)"
              ></b-avatar>
              <h6 :title="`${customer.user.firstName} ${customer.user.lastName}`"
                class="font-sm cy-current-customer-name font-family-medium primary--text reduce-line-height pl-3"
              >
                {{ ellipsify(`${customer.user.firstName} ${customer.user.lastName}`, 30) }}
              </h6>
            </b-col>
            <b-col cols="2" class="">
              <h6
                class="font-sm cy-current-customer-sub primary--text font-weight-normal text-capitalize"
              >
                {{ getCompanyMembership(customer) }}
              </h6>
            </b-col>
            <b-col cols="2" class="">
              <h6
                class="font-sm cy-current-customer-employer primary--text font-weight-normal reduce-line-height"
              >
                {{ getCompanyName(customer) }}
              </h6>
            </b-col>
            <b-col
              cols="2"
              v-if="customer.assignedAssistants.length > 0"
              class="d-flex align-items-center position-relative"
            >
              <b-avatar
                size="4.4rem"
                class="pa-avatar bg--primary"
                :src="customer.assignedAssistants[0].avatarThumbnail"
                :text="userInitials(customer.assignedAssistants[0])"
              ></b-avatar>
              <div class="d-flex flex-column">
                <h6
                  class="font-sm cy-current-customer-assign-pa primary--text font-family-medium ml-3 mt-1 reduce-line-height"
                >
                  {{
                    `${customer.assignedAssistants[0].firstName} ${customer.assignedAssistants[0].lastName}`
                  }}
                </h6>
                <span
                  class="primary--text font-weight-normal ml-3"
                  v-if="customer.assignedAssistantsCount > 1"
                  >+
                  {{ customer.assignedAssistantsCount - 1 }}
                  more</span
                >
              </div>
            </b-col>
            <b-col
              cols="2"
              v-if="customer.assignedAssistantsCount === 0"
              class="d-flex align-items-center position-relative"
            >
              <h6 class="font-sm primary--text ">N/A</h6>
            </b-col>
            <b-col
              cols="2"
              v-if="customer.assignedOwners && customer.assignedOwners.length > 0"
              class="d-flex align-items-center position-relative"
            >
              <b-avatar
                size="4.4rem"
                class="pa-avatar bg--primary"
                :src="customer.assignedOwners[0].avatarThumbnail"
                :text="userInitials(customer.assignedOwners[0])"
              ></b-avatar>
              <div class="d-flex flex-column">
                <h6
                  class="font-sm cy-current-customer-owner primary--text font-family-medium ml-3 mt-1 reduce-line-height"
                >
                  {{
                    `${customer.assignedOwners[0].firstName} ${customer.assignedOwners[0].lastName}`
                  }}
                </h6>
                <span
                  class="primary--text font-weight-normal ml-3"
                  v-if="customer.assignedOwnersCount > 1"
                  >+
                  {{ customer.assignedOwnersCount - 1 }}
                  more</span
                >
              </div>
            </b-col>
            <b-col
              cols="2"
              v-else
              class="d-flex align-items-center position-relative"
            >
              <h6 class="font-sm primary--text ">N/A</h6>
            </b-col>
            <b-col cols="1">
              <h6 class="font-sm cy-current-customer-date primary--text mt-2">
                {{ getCreatedAt(customer) }}
              </h6>
            </b-col>
            <b-col cols="1"
              class="d-flex position-relative justify-space-around"
              v-if="!internalCustomerEmailSet.has(customer.user.email)"
            >
              <div class="cy-current-customers-archive">
                <div
                  @click.stop="showArchiveModal(customer)"
                  v-if="
                    !archiveHover ||
                      (showInactiveArchiveHover &&
                        activeArchiveHoverId !== customer.id)
                  "
                  class="empty-icon-avatar d-flex align-items-center justify-content-center"
                >
                  <img
                    class="cursor-pointer"
                    src="@/assets/icons/arrow_down_square.svg"
                    alt
                  />
                </div>
                <div
                  @click.stop="showArchiveModal(customer)"
                  class="archive-hover-avatar position-relative d-flex align-items-center justify-content-center"
                  v-if="archiveHover && activeArchiveHoverId === customer.id"
                >
                  <img
                    src="@/assets/icons/arrow_down_square_hover.svg"
                    alt=""
                  />
                </div>
              </div>
            </b-col>
          </b-card-body>
        </b-card>
      </b-col>
      <infinite-loading
        spinner="spiral"
        :identifier="currentCustomersID"
        @infinite="infiniteHandlerCurrentCustomers"
      >
        <div slot="no-more">
          <h4 class="font-md primary--text font-family-medium mt-5 mb-5">
            No more customers to load.
          </h4>
        </div>
        <div slot="no-results">
          <h4 class="font-md primary--text font-family-medium mt-5 mb-5">
            No more customers to load.
          </h4>
        </div>
      </infinite-loading>
    </div>

    <b-modal
      centered
      modal-class="cy-current-customer-modal"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      v-model="showArchive"
      v-if="showArchive"
    >
      <b-container fluid>
        <b-button
          @click="closeModal"
          class="cy-current-customer-close d-flex position-absolute close-btn"
        >
          <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
        </b-button>
        <b-row class="pt-2 pl-4 d-flex flex-column">
          <h2
            v-if="isCustomerArchived"
            class="font-md cy-current-customer-success-header modal_header ml-2"
          >
            Successfully archived
          </h2>
          <h4
            v-if="!isCustomerArchived"
            class="font-md cy-current-customer-subtext subtext mb-4 mt-3 ml-2"
          >
            Do you want to archive the following profile?
          </h4>
          <h4
            v-else
            class="font-md cy-current-customer-subtext-success subtext mb-4 mt-1 ml-2"
          >
            Following customer has been successfully archived.
          </h4>
        </b-row>
        <b-row align-v="center">
          <b-col md="9" class="flex-row d-flex mb-4">
            <div>
              <b-avatar
                v-if="selectedCustomerAvatar"
                :src="selectedCustomerAvatar"
                size="8rem"
                class="pa-avatar bg--primary"
              ></b-avatar>
              <b-avatar
                v-else
                :text="selectedCustomerInitials"
                size="8rem"
                class="pa-avatar bg--primary"
              ></b-avatar>
            </div>
            <div
              class="d-flex flex-column justify-content-center position-relative ml-4"
            >
              <p
                class="cy-current-customer-fullName font-family-medium primary--text mt-2"
              >
                {{ selectedCustomerFullName }}
              </p>
              <p
                class="cy-current-customer-email secondary--text reduce-whitespace"
              >
                {{ selectedCustomerEmail }}
              </p>
              <div class="">
                <b-button
                  class="text-uppercase btn-chip btn-danger--light danger font-family-regular btn-chip--pill"
                  >{{ `Type - ${selectedCustomerMembership.title || 'N/A'}` }}</b-button
                >
              </div>
            </div>
          </b-col>
          <div
            v-b-tooltip.hover :title="!selectedCustomer.customerProfile.endDate ? 'Please update End Date to enable archive.': ''"
          >
          <b-button
            @click="archiveCustomer"
            v-if="!isCustomerArchived"
            :disabled="!selectedCustomer.customerProfile.endDate"
            class="cy-current-customer-archive btn-primary px-5 py-3 btn-pill ml-2 reduce-whitespace"
          >
            <b-spinner
              v-if="isSavingArchive"
              style="width: 14px; height: 14px"
              variant="light"
              label="Spinning"
            ></b-spinner>
            {{ `${isSavingArchive ? "" : archiveBtnText}` }}
          </b-button>
          </div>
        </b-row>
        <b-row v-if="archiveError" class="archive-error">
          <b-col>
            {{ archiveError }}
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </b-row>
</template>

<script>
import moment from "moment";
import { archiveOrDeleteAccount, getCurrentCustomers } from "@/apis/customers";
import { ellipsify, getInitials } from "@/utils/utils";
import { internalCustomerEmailSet } from "@/utils/constants";

export default {
  name: "CurrentCustomers",
  props: [
    "selectedSubscriptionId",
    "filteredCustomerId",
    "selectedCompanyId"
  ],
  mounted() {
    this.changeType();
  },
  data() {
    return {
      currentCustomersList: [],
      archiveError: null,
      expandHover: false,
      archiveHover: false,
      deleteHover: false,
      activeExpandHoverId: "",
      inactiveExpandHoverId: "",
      showInactiveExpandHover: true,
      activeArchiveHoverId: "",
      inactiveArchiveHoverId: "",
      showInactiveArchiveHover: true,
      activeDeleteHoverId: "",
      inactiveDeleteHoverId: "",
      showInactiveDeleteHover: true,
      showArchive: false,
      selectedCustomerFullName: "",
      selectedCustomerEmail: "",
      selectedCustomerAvatar: "",
      selectedCustomerInitials: "",
      selectedCustomerMembership: "",
      selectedCustomer: "",
      isSavingArchive: false,
      internalCustomerEmailSet: internalCustomerEmailSet,
      isCustomerArchived: false,
      archiveBtnText: "Archive",
      isDelete: null,
      currentCustomersID: +new Date(),
      offsetCurrentCustomer: 0
    };
  },
  methods: {
    getInitials,
    ellipsify,
    getCompanyMembership(customer){
      return customer.customerProfile.membership
        ? customer.customerProfile.membership.title
        : "N/A";
    },
    getCompanyName(customer) {
      return customer.customerProfile.company
        ? customer.customerProfile.company.name
        : "N/A";
    },
    getCreatedAt(customer) {
      return customer.customerProfile.created
        ? this.getFormattedDate(customer.customerProfile.created)
        : "N/A";
    },

    changeType() {
      this.currentCustomersList = [];
      this.offsetCurrentCustomer = 0;
      this.currentCustomersID += 1;
    },
    infiniteHandlerCurrentCustomers($state) {
      let data = {
        membership: this.selectedSubscriptionId,
        id: this.filteredCustomerId,
        company: this.selectedCompanyId
      };
      getCurrentCustomers(30, this.offsetCurrentCustomer, data).then(res => {
        let customersList = res.data.results;
        this.currentCustomersList = [
          ...this.currentCustomersList,
          ...customersList
        ];
        this.offsetCurrentCustomer = res.data.offset;
        if (res.data.next === null) {
          $state.complete();
        } else {
          $state.loaded();
        }
      });
    },
    navigate(customer) {
      if (!customer.isProfileIntakeSubmitted) {
        this.$router.push({
          name: "ClientIntake",
          params: {
            profileId: customer.id
          }
        });
      } else {
        this.$router.push({
          name: "CustomerDetails",
          params: {
            profileId: customer.id
          },
          query: {
            tab: 2
          }
        });
      }
    },
    userInitials(user) {
      let initials = `${user.firstName.split(" ")[0]} ${user.lastName}`;
      return initials.match(/\b(\w)/g).join("");
    },
    getFormattedDate(date) {
      return moment(date).format("MM/DD/YYYY");
    },
    showArchiveModal(profile) {
      let { user } = profile;
      this.selectedCustomer = profile;
      this.selectedCustomerFullName = `${user.firstName} ${user.lastName}`;
      this.selectedCustomerInitials = this.selectedCustomerFullName
        .match(/\b(\w)/g)
        .join("");
      this.showArchive = true;
      this.selectedCustomerEmail = user.email;
      this.selectedCustomerAvatar = user.avatarThumbnail;
      this.selectedCustomerMembership = profile.customerProfile.membership;
    },
    archiveCustomer() {
      this.isSavingArchive = true;
      const data = {
        profile: this.activeArchiveHoverId,
        isDelete: false
      };
      archiveOrDeleteAccount(data)
        .then(() => {
          this.isSavingArchive = false;
          this.isCustomerArchived = true;
          this.currentCustomersList = this.currentCustomersList
            .filter(item => item !== this.selectedCustomer)
            .filter(customer => {
              if (!this.$route.query.company) {
                return true;
              }

              let company = customer.customerProfile.company;
              if (company) {
                return company.id === this.$route.query.company;
              }

              return false;
            });
        })
        .catch(err => {
          this.archiveError = err.response.data.detail;
          this.isSavingArchive = false;
        });
    },
    closeModal() {
      this.showArchive = false;
      this.archiveError = null;
      this.isCustomerArchived = false;
    },
    showCardHover(id) {
      this.activeExpandHoverId = id;
      this.expandHover = true;
      this.showInactiveExpandHover = true;
      this.activeArchiveHoverId = id;
      this.archiveHover = true;
      this.showInactiveArchiveHover = true;
      this.activeDeleteHoverId = id;
      this.deleteHover = true;
      this.showInactiveDeleteHover = true;
    },
    undoCardHover(id) {
      this.inactiveExpandHoverId = id;
      this.expandHover = false;
      this.inactiveArchiveHoverId = id;
      this.archiveHover = false;
      this.inactiveDeleteHoverId = id;
      this.deleteHover = false;
    }
  }
};
</script>

<style scoped lang="scss">
.relative-top {
  top: 0.3rem;
}
.relative-right {
  right: 0.3rem;
}
.actions-header {
}
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
.card {
  cursor: pointer;
}
</style>
